/**
 * TanStack Query — singleton QueryClient pra app.
 *
 * Pattern recomendado pelo [tkdodo](https://tkdodo.eu/blog/using-web-sockets-with-react-query):
 * - 1 QueryClient global (criado no module-load, vive o ciclo do app)
 * - WS handlers chamam `queryClient.setQueryData(['onus', filters], …)` pra
 *   patch in-place quando flips chegam (PR 1.14.1 / TD26-23)
 *
 * Defaults conservadores:
 * - `staleTime: 30s` — dados frescos por 30s sem refetch (alinhado com cache
 *   Redis no backend; refetch desnecessário porque push delta WS já invalida).
 * - `gcTime: 5min` — quanto a query inativa fica em memória antes do GC.
 * - `refetchOnWindowFocus: false` — operador alterna janelas; refetch a cada
 *   foco vira flicker no cockpit. Push delta WS já cuida da freshness real-time.
 * - `retry: 1` — uma tentativa extra (rede flaky), depois exibe erro.
 *
 * Errores 4xx (auth, validação) não retentam — handled pelo `apiFetch` (401
 * dispara logout) e zod (validation lança ApiError sem retry).
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
